import { DS_getData } from '../DS/DS.Data'
import { IDB_doneReports } from '../IDB/IDB.dexie'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Proc_getProcedures } from '../Proc/Proc.getProcedures'
import type { Todo_DoneReportDPO } from '../Todo/Todo.DoneReport'
import { User_get } from '../User/User.get'

type ProcedureTraining = {
    id: number
    name: string
    training: TrainingLatestReport[]
}

type TrainingLatestReport = {
    id: number
    name: string
    report: Todo_DoneReportDPO
}

export async function getRecentForProcedureTraining(): Promise<ProcedureTraining[]> {
    const logger = Logg_createLogger('Rpts.getRecentForProcedureTraining')
    const procedures = await Proc_getProcedures(logger, DS_getData().user)
    const doneReports = await IDB_doneReports().orderBy('startDate').toArray()
    const doneReportsLookup: Map<string, Todo_DoneReportDPO> = new Map(
        doneReports.map((r) => [`${r.workflow}:${r.procedure}:${r.author}`, r])
    )

    const completedTrainingForProcedure: ProcedureTraining[] = []

    procedures.forEach((procedure) => {
        procedure.workflows
            .filter((training) => training.type === 'training')
            .forEach((training) => {
                const recentTrainingReport = doneReportsLookup.get(`${training.id}:${procedure.id}:${User_get().id}`)

                if (recentTrainingReport) {
                    let procedureTrainingData = completedTrainingForProcedure.find((pt) => pt.id === procedure.id)
                    if (!procedureTrainingData) {
                        procedureTrainingData = {
                            id: procedure.id,
                            name: procedure.name,
                            training: [],
                        }
                        completedTrainingForProcedure.push(procedureTrainingData)
                    }
                    procedureTrainingData.training.push({
                        id: training.id,
                        name: training.name,
                        report: recentTrainingReport,
                    })
                }
            })
    })

    return completedTrainingForProcedure
}
